import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { isNullOrUndefined } from '../../../../utils/general'

export default class ShipInputTextField extends PureComponent {
  static propTypes = {
    category: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="ship-detail-group">
        <label className={`ship-detail category ${this.props.error ? 'error' : ''}`} htmlFor={this.props.name}>
          {this.props.category}
        </label>
        <input
          className={`input-field ${this.props.error ? 'error' : ''}`}
          value={!isNullOrUndefined(this.props.value) ? this.props.value : ''}
          onChange={this.handleChange}
          id={this.props.name}
          type="text"
          disabled={this.props.readOnly === true}
        />
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }

  handleChange = event => {
    this.props.onChange(event.target.value, this.props.name)
  }
}
